"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e={authentication:null,token:null,refreshToken:null,missingConsents:null};exports.emptyCredential=e;
